/** How a user is named in a title or a link: full name, else email, else `User #id`.
 *
 *  `first_name` / `last_name` are nullable (imported guests and placeholder accounts
 *  arrive with both null), so a template literal over them renders "null null". */
export function userDisplayName(u: {
  id: number;
  first_name: string | null;
  last_name: string | null;
  email?: string | null;
}): string {
  const name = [u.first_name, u.last_name]
    .map((part) => part?.trim())
    .filter(Boolean)
    .join(' ');
  return name || u.email?.trim() || `User #${u.id}`;
}
